"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackExpirationReminderSubscriptionSelected = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
function trackExpirationReminderSubscriptionSelected(clickElement) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventData: {
            eventName: enums_1.GA4EventName.SelectCheckBox,
            feature_category: enums_1.GA4FeatureCategory.CustomerAccount,
            click_element: clickElement,
        },
    });
}
exports.trackExpirationReminderSubscriptionSelected = trackExpirationReminderSubscriptionSelected;
//# sourceMappingURL=trackExpirationReminderSubscriptionSelected.js.map